import { Localization } from "../../../common/localizable-component";
import { DropdownLocalization } from "./dropdown-types";

export const DROPDOWN_LOCALIZATION: Localization<DropdownLocalization> = {
  en: {
    required: "This field is required.",
    selected: "selected"
  },
  de: {
    required: "Dieses Feld wird benötigt.",
    selected: "ausgewählt"
  },
  sv: {
    required: "Det här fältet är obligatoriskt.",
    selected: "utvalda"
  },
  nl: {
    required: "Dit veld is verplicht.",
    selected: "geselecteerde"
  },
  it: {
    required: "Questo campo è obbligatorio.",
    selected: "selezionato"
  },
  hu: {
    required: "Ez a mező kötelező.",
    selected: "kiválasztott"
  },
  da: {
    required: "Dette felt er obligatorisk.",
    selected: "udvalgt"
  },
  fr: {
    required: "Ce champ est obligatoire.",
    selected: "sélectionné"
  },
  es: {
    required: "Este campo es obligatorio.",
    selected: "seleccionado"
  },
  pl: {
    required: "To pole jest wymagane.",
    selected: "wybrane"
  },
  ro: {
    required: "Acest câmp este obligatoriu.",
    selected: "selectat"
  },
  hr: {
    required: "Ovo polje je obavezno.",
    selected: "odabran"
  },
  cs: {
    required: "Toto pole je povinné.",
    selected: "vybrané"
  },
  sl: {
    required: "To polje je obvezno.",
    selected: "izbrani"
  }
};
